var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"stripe-payment-element"}}),(_vm.errorMessage)?_c('p',{staticStyle:{"color":"#d32f2f","margin-top":"12px"}},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }